module.exports = __webpack_public_path__ + "static/media/cert_90.dfcd6dc2.jpg";